import appLocalStorage from '@/features/session/appLocalStorage';
import React, { useEffect } from 'react';

interface MicrofrontendAuthProviderProps {
  children: React.ReactNode;
}

const normalizeOrigin = (url: string) => {
  try {
    const u = new URL(url);
    // Remove trailing slash for consistency
    return u.origin;
  } catch {
    return '';
  }
};

const MicrofrontendAuthProvider: React.FC<MicrofrontendAuthProviderProps> = ({ children }) => {

  /** DO NOT ADD CONSOLE LOGS inside handleAuthRequest function */
  useEffect(() => {
    const allowedOrigins = [normalizeOrigin(import.meta.env.VITE_APP_STM_URL)];

    const handleAuthRequest = (event: MessageEvent) => {

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      if (event.data?.type === 'REQUEST_AUTH_TOKEN') {
        const hostToken = appLocalStorage.getTokenData();
        const hostUser = appLocalStorage.getUserAccessProfile();
        const productionUnit = appLocalStorage.getProductionUnit();

        (event.source as Window)?.postMessage(
          {
            type: 'HOST_AUTH_TOKEN',
            token: hostToken,
            user: hostUser,
            productionUnit,
          },
          event.origin // use verified origin
        );

        /** DO NOT ADD CONSOLE LOGS inside handleAuthRequest function */
      }
    };

    window.addEventListener('message', handleAuthRequest);
    return () => window.removeEventListener('message', handleAuthRequest);
  }, []);

  return <>{children}</>;
};

export default MicrofrontendAuthProvider;
